export default __webpack_public_path__ + "static/media/agatha-depine-dJL6L7YFh5c-unsplash.a3fa7751.jpg";